import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component({
    components: {

    },
    // 过滤器 格式化金额
    filters: {
      Money(data: number) {
        return typeof(data) === 'number' ? '+' + data.toFixed(2) : data;
      },
    },
})
export default class RechargeList extends Vue {
  private $api: any;
  private rechargelist: any = [];
  private loading: boolean = false;
  private pageIndex = 1;
  private status: number = 0; // 0 正常, 1 数据全部加载, 2 加载失败
  private scrollView: any = null; // 记录被滚动的元素
  private RechargeDate: any = '';
  private canRechargeDialog: boolean = false; // 额度已达上限的提示对话框
  private isGettingRechargeStatus: boolean = false; // 正在获取充值额度状态 

  // 时间选择器
  private show: boolean = false;
  private minDate: any = new Date(2019, 1);
  private currentDate: any = new Date();

  // 获取充值记录列表
  private async getRechargeList() {
    this.loading = true;  // 显示加载中字样
    this.status = 0;      // 隐藏"没有更多了"，"获取失败"字样

    const params = {
      // 分页
      paging: {
        pageIndex: this.pageIndex,  // 索引
        pageSize: 10,   // 长度
      },
      // 查询条件
      entity: {
        RechargeDate: this.RechargeDate,  // 月份
      },
    };
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/QueryUserRechargeWeChat', params);
    if (result.Success) {
      // console.log(result.Data);
      // this.rechargelist = result.Data;
      if (result.Data.length !== 0) {

        for (const item of result.Data) {
          this.rechargelist.push(item);
        }

        this.status = 0;
      } else {
        this.status = 1;
        this.pageIndex = this.pageIndex - 1;
      }
    } else {
      this.status = 2;
      this.pageIndex = this.pageIndex - 1;
    }
    this.endLoading();
  }

  // 监听滑动到底部
  private onScroll(event: any) {
    this.scrollView = event.target;
    const scrollTop = this.scrollView.scrollTop;
    const clientHeight = this.scrollView.clientHeight;
    const scrollHeight = this.scrollView.scrollHeight;
    // 算法：scrollTop + clientHeight >= scrollHeight
    // 有时候拉到底却不触发事件，为了确保会触发，条件里减去1
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      this.loadNextPage();
    }
  }

  // 加载下一页
  private async loadNextPage() {
    if (this.loading) {
      return;
    }
    
    this.pageIndex = this.pageIndex + 1;
    // console.log(this.pageIndex);

    this.getRechargeList();
  }

  // 上拉加载结束
  private endLoading() {
    this.loading = false;
    // 回滚 (用于解决无限触发滚动事件的bug)
    if (!this.scrollView) {
      return;
    }
    this.scrollView.scrollTop = this.scrollView.scrollTop - 10;
    // console.log(this.scrollView.scrollTop);
  }


  // 格式化时间
  private formatter(type: string, value: string) {
    if (type === 'year') {
      return `${value}年`;
    } else if (type === 'month') {
      return `${value}月`;
    }
    return value;
  }

  // 弹出时间选择器
  private pickDate() {
    this.show = true;
  }

  private changeDate(value: string) {
    this.RechargeDate = moment(value).format('YYYY-MM');
    this.cancel();
    this.pageIndex = 1;           // 重置页数索引
    this.rechargelist.length = 0; // 清空当前列表
    this.getRechargeList();
  }

  // 取消弹窗
  private cancel() {
    this.show = false;
  }

  private clearDate(event: any) {
    // console.log(event);
    event.stopPropagation(); // 阻止事件冒泡，否则会弹出时间选择器
    this.RechargeDate = '';
    this.pageIndex = 1;           // 重置页数索引
    this.rechargelist.length = 0; // 清空当前列表
    this.getRechargeList();
  }


  // 查看详情
  private showDetails(item: any) {
    this.$store.commit('saveRechargeInfo', item);   // 提交到vuex
    // 本地缓存 (只使用vuex刷新数据会丢失，本来就打算这样设计，但测试需求要可以刷新)
    localStorage.setItem('RechargeInfo', JSON.stringify(item)); 
    this.$router.push('/recharge-details');
  }

  // 充值
  private async recharge() {
    if (this.isGettingRechargeStatus) {
      return;
    }
    this.isGettingRechargeStatus = true;
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/JudgeRechargeButton');
    if (result.Success) {
      if (result.Data) {
        // 如果可以充值
        this.$router.push('/recharge');
      } else {
        // 如果充值额度已用完
        this.canRechargeDialog = true;
      }
    } else {
      this.$notify(result.AllMessages);
    }
    this.isGettingRechargeStatus = false;
  }

  // life cycle
  private mounted() {
    this.getRechargeList();
  }

}
